import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import {
  selectTenantFeatureById,
  selectSchedulingEligibility,
} from '@user/store/tenantFeatures'

export function useSchedulingEnabled() {
  const estimates = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.Estimates),
  )

  const eligible = useAppSelector(selectSchedulingEligibility)

  return eligible && (estimates?.enabled ?? false)
}
